// extracted by mini-css-extract-plugin
module.exports = {"btn--transparent":"TransparentButton_btn--transparent__3neAG"};